import { render } from "./assigned-site.vue?vue&type=template&id=012eb38b&scoped=true"
import script from "./assigned-site.vue?vue&type=script&lang=js"
export * from "./assigned-site.vue?vue&type=script&lang=js"

import "./assigned-site.vue?vue&type=style&index=0&id=012eb38b&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012eb38b"]])

export default __exports__